import React, { useState, useEffect } from 'react';
import { Table, Typography } from 'antd';
import { getDailyBalance } from '../../../../../api/EmiPayments';
import { useSelector } from 'react-redux';
import CustomAmountText from '../../../../common/CustomAmountText';
import { CURRENCY } from '../../../../../utils/ConstantData';
import { CurrencyFormatWithDecimal } from '../../../../../helper/CurrencyFormate';

const DailyBalanceReport = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [months, setMonths] = useState([]);
  const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let aggregate = selectedAccountId !== 'all' ? false : true;
        let account_id = selectedAccountId !== 'all' ? selectedAccountId : reportDetails?.report?.reportId;
        const response = await getDailyBalance(account_id, aggregate);
        const { month, day } = response;

        setMonths(month);

        // Transform the data and add "Average" column
        const transformedData = Object.keys(day).map(dayKey => {
          const dayData = day[dayKey].reduce((acc, curr) => {
            acc[curr.month] = curr.amount;
            if (curr.month === 'Average') {
              acc['average'] = curr.amount; // Store the average amount
            }
            return acc;
          }, { dayOfMonth: dayKey });
          return dayData;
        });

        setTableData(transformedData);
      } catch (error) {
        console.error("Failed to fetch data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (selectedAccountId) {
      fetchData();
    }
  }, [selectedAccountId]);

  const columns = [
    {
      title: 'Day of Month',
      dataIndex: 'dayOfMonth',
      key: 'dayOfMonth',
      fixed: 'left',
      width: 100,
    },
    {
      title: `Average (${CURRENCY})`,
      dataIndex: 'Average',
      key: 'Average',
      fixed: 'left',
      width: 150,
      render: (value) => (
        <CustomAmountText shouldDisplayCurrency={true} value={value} />
      )
    },
   
    ...months.map(month => ({
      title: `${month} (${CURRENCY})`,
      dataIndex: month,
      key: month,
      width: 150,
      align: 'right',
      render: (amount) => amount ? <CustomAmountText shouldDisplayCurrency={true} value={amount} /> : '',
    }))
  ];

  return (
    <Table
      columns={columns}
      dataSource={tableData}
      loading={loading}
      pagination={{ pageSize: 50 }}
      scroll={{ x: 1500 }}
      bordered
      rowClassName={(record, index) => {
        const isLastTwoRows = index >= tableData.length - 2;
        return isLastTwoRows ? 'highlight-row' : '';
      }}
    />
  );
};

export default DailyBalanceReport;
